export { injectable } from 'inversify';

import { diContainer } from './di';
import { type DiEntityIdentifier } from './types';

export const inject = <T>(identifier: DiEntityIdentifier) => {
  return diContainer.get<T>(identifier);
};
